module.exports = __webpack_public_path__ + "img/img5.a39a63e9.png";